import { toJS } from "mobx";
import { getStore } from "../store";
import type { TimeZoneRange } from "../TimeZoneRange";

/**
 * Retrieves time zone offsets for the default time zone
 */
export default function getDefaultTimeZoneOffsets(): TimeZoneRange[] {
    const { TimeZoneRanges, LocalTimeZone } = getStore();
    return toJS(TimeZoneRanges[LocalTimeZone] || []);
}
